import React from "react";
import { useUscSelector } from "../../../../../redux/store";
import { useUscLabel } from "../../../../../utils/labels";
import UscBasketItemWrapper from "../common/UscBasketItemWrapper";
import BasketAccessoryPackItem from "./BasketAccessoryPackItem";

const BasketAccessories = (): JSX.Element | null => {
    const selectedAccessories = useUscSelector((state) => state.basket.configuration.accessories);
    const selectedPacks = useUscSelector((state) => state.basket.configuration.packs);
    const titleLabel = useUscLabel("uscBasketAccessoriesTitle");

    const selectedAccessoriesAndPacks = selectedAccessories.concat(selectedPacks);

    if (!selectedAccessoriesAndPacks.length) return null;

    return (
        <div data-testid="usc-basketaccessories">
            <UscBasketItemWrapper title={titleLabel}>
                {selectedAccessoriesAndPacks.map((item) => (
                    <BasketAccessoryPackItem key={item.id} accessoryOrPack={item} />
                ))}
            </UscBasketItemWrapper>
        </div>
    );
};

export default BasketAccessories;
